'use strict';

var SiteConstants = require('constants/SiteConstants');
var updateMiniCart = true;
var miniCartRequest = 0;
var cart = require('./../cart/cart');
var updateMiniCartCount = cart.updateMiniCartCount;
var abSlider = require('./slider');

function setMiniCartBodyMaxHeight(minicart) {
    $(minicart).css({
        '--minicart-header-height': $('.minicart-header').outerHeight() + 'px',
        '--minicart-footer-height': $('.minicart-footer').outerHeight() + 'px'
    })

}

function handleMiniCartEvent() {
    if(!$('header').hasClass('checkout-header')) {
        var url = $('.minicart').data('action-url');
        $('#minicartModal').modal();
        var miniCartPopulated = $('.minicart .modal .minicart-content').children().length > 0 ? true : false;

        if (!miniCartPopulated || updateMiniCart) {
            $('.minicart .modal .modal-drawer').spinner().start();
            // LEG-605: two mini cart loads can overlap (a bag tap, then an add to cart); only the answer of the latest load fills or closes the drawer, so an earlier answer never shows an old mini cart or lifts the loading layer
            var request = ++miniCartRequest;
            $.get(url, data => {
                if (request !== miniCartRequest) {
                    return;
                }
                $('.minicart .modal .modal-content .minicart-content').empty().append(data);
                updateMiniCart = false;
                $.spinner().stop();
                // LEG-625: the reload can drop the control that had the focus (a keyboard removal); refocus the open drawer so Escape and Tab still work
                var $drawer = $('#minicartModal');
                if ($drawer.hasClass('show') && !$drawer[0].contains(document.activeElement)) {
                    $drawer[0].focus();
                }
                $('body').trigger('minicart:loaded', $('.minicart .modal'));
                $('body').trigger('minicart:slider', $('.minicart .modal'));
                setMiniCartBodyMaxHeight($('.minicart .modal'));
            }).fail(() => {
                if (request !== miniCartRequest) {
                    return;
                }
                // LEG-625: a mini cart that cannot load closes instead of staying under its spinner; the next open loads it again
                $.spinner().stop();
                $('#minicartModal').removeClass('show');
                setTimeout(() => {
                    $('#minicartModal').modal('hide');
                }, SiteConstants.TransitionSpeed);
            });
        } else {
            var $modal = $('.minicart .modal');
            // Reinitialize mobile modal sliders to prevent tiny slider error on drag
            var $modalSlider = $modal.find('.slider-container .slider');
            if ($modalSlider.length) {
                $modalSlider.trigger('slider:destroy');
                abSlider.initializeSliders($modal);
            }
        }
    }
}

module.exports = function () {
    $('.minicart').on('count:update', (event, count) => {
        updateMiniCartCount(count.cart);
    });

    $('.minicart-link').on('click touchstart', (e) => {
        e.preventDefault();
        if(!$('header').hasClass('checkout-header')) {
            handleMiniCartEvent();
        } else if ($('header').hasClass('checkout-header')) {
            window.location.href = $(e.currentTarget).attr('href');
        }
    });

    $('body').on('touchstart click', '.minicart', event => {
        if ($('.minicart .modal-drawer').has(event.target).length <= 0 && $('.minicart .minicart-total').has(event.target).length <= 0) {
            $('#minicartModal').removeClass('show');

            setTimeout(() => {
                $('#minicartModal').modal('hide');
            }, SiteConstants.TransitionSpeed);
        }
    });

    $('body').on('change', '.minicart .quantity', event => {
        if ($(event.target).parents('.bonus-product-line-item').length && $('.cart-page').length) {
            location.reload();
        }
    });

    $('body').on('cart:update', () => {
        updateMiniCart = true;
        setMiniCartBodyMaxHeight($('.minicart .modal'));
    });

    $('body').on('product:afterAddToCart', () => {
        updateMiniCart = true;
        // LEG-605: each add to cart handler stops the page spinner right after this event; empty the drawer and load it after that, so the loading layer shows instead of the old mini cart
        setTimeout(() => {
            $('.minicart .modal .modal-content .minicart-content').empty();
            handleMiniCartEvent();
        }, 0);
    });

    // LEG-625: the remove handler asks for the server's empty mini cart while the drawer stays open
    $('body').on('minicart:refresh', () => {
        updateMiniCart = true;
        handleMiniCartEvent();
    });

    $('body').on('minicart:loaded cart:afterUpdate', (event, minicart) => {
        setMiniCartBodyMaxHeight(minicart);
    });

};